import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.VIRTUAL_INSTANCES_QTY,
  displayName: "Xray",
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "jpd-icon",
    title: "Additional Platform",
    valueTransformer: (value) => value,
    valueTransformerSH: (value) => {
      return { display: value !== "N/A", value: value };
    },
    tooltip: {
      text: "JFrog Platform with <br> Artifactory and Xray",
    },
  },
};

export default entitlement;
